import React from 'react';
import { useParams } from 'react-router-dom';
import AddContractor from './AddContractor';

const EditSubcontractor = () => {
  const { id } = useParams();

  return <AddContractor editMode={true} vendorId={id} />;
};

export default EditSubcontractor;

